import { gql } from "@apollo/client";

export const REGION_INFO = gql`
  query queryRegion($id: Float!) {
    region(id: $id) {
      id
      name
      latitude
      longitude
      ibge
      is_actived
      is_deleted
    }
  }
`;

export const REGIONS = gql`
  query queryRegions($franchise_id: Float) {
    regions(franchise_id: $franchise_id) {
      id
      name
      latitude
      longitude
      ibge
      is_actived
      is_deleted
    }
  }
`;

export default REGION_INFO;
